export function isArray(arr: any): boolean {
  return arr && arr.constructor === Array;
}
